import React from "react";

const PeopleIcon = ({ color = "#424242", ...props }) => (
  <svg width={42} height={37} viewBox="0 0 42 37" {...props}>
    <path
      fill={color}
      d="M14.045 17.261c.19-.007.382-.011.575-.011.624 0 1.13.508 1.13 1.135v.01a1.13 1.13 0 0 1-1.13 1.126c-6.827 0-12.36 5.527-12.36 12.344 0 .627-.505 1.135-1.13 1.135C.506 33 0 32.492 0 31.865c0-6.4 4.114-11.838 9.842-13.817A8.612 8.612 0 0 1 6 10.875C6 6.112 9.87 2.25 14.642 2.25a1.107 1.107 0 1 1 0 2.212c-3.549 0-6.426 2.87-6.426 6.413 0 3.341 2.56 6.085 5.829 6.386zm11.172 3.735a1.14 1.14 0 0 1-.092.004C17.048 21 10.5 27.548 10.5 35.625a1.125 1.125 0 0 1-2.25 0c0-7.571 4.986-13.978 11.854-16.116A10.495 10.495 0 0 1 15 10.5C15 4.701 19.701 0 25.5 0S36 4.701 36 10.5 31.299 21 25.5 21a8.86 8.86 0 0 1-.283-.004zm.083-2.232l.2.002a8.266 8.266 0 1 0-.51-.015l.135-.001c.06 0 .118.005.175.014zM42 35.625a1.125 1.125 0 0 1-2.25 0c0-4.002-1.614-7.744-4.425-10.48a1.125 1.125 0 0 1 1.57-1.613A16.825 16.825 0 0 1 42 35.625z"
    />
  </svg>
);

export default PeopleIcon;
